import React from 'react';
import { FullscreenOverlay } from '@99designs/spa-common';
import { FullscreenFrame } from '@99designs/spa-common';
import { FullscreenFrameMain } from '@99designs/spa-common';
import { FullscreenFrameSidebar } from '@99designs/spa-common';
import { FullscreenMain } from '@99designs/spa-common';
import { FullscreenMainHeader } from '@99designs/spa-common';
import { FullscreenMainBody } from '@99designs/spa-common';
import { FullscreenFrameMainWrapper } from '../FileOverlay/FileOverlay';
import FileOverlayContextProvider from '../FileOverlay/FileOverlayContext/FileOverlayContext';
import PreviewAlert from '../FileOverlay/PreviewAlert';
import usePresentationMode from '../FileOverlay/usePresentationMode/usePresentationMode';
import KissFilePane from './KissFilePane/KissFilePane';
import KissHeader from './KissHeader/KissHeader';
import { KissFile } from './types';

export interface KissFileOverlayProps {
    showFileOverlay: boolean;

    file: KissFile;
    totalFilesCount: number;
    currentFileIndex: number;
    nextFile: () => void;
    previousFile: () => void;
    closeOverlayHandler: () => void;

    sidebarComponent: React.ReactNode;
}

function KissFileOverlay({
    file,
    showFileOverlay,
    sidebarComponent,
    totalFilesCount,
    currentFileIndex,
    nextFile,
    previousFile,
    closeOverlayHandler,
}: KissFileOverlayProps) {
    const { handleMaximize, handleMinimize, isPresentationMode } = usePresentationMode();

    const isSidebarHidden = !sidebarComponent || isPresentationMode;
    const navNext = currentFileIndex + 1 < totalFilesCount ? nextFile : undefined;
    const navPrev = currentFileIndex - 1 >= 0 ? previousFile : undefined;

    return (
        <FileOverlayContextProvider file={file}>
            {showFileOverlay && (
                <FullscreenOverlay isActive={true}>
                    <FullscreenFrame>
                        <FullscreenFrameMainWrapper>
                            <FullscreenFrameMain isSidebarHidden={isSidebarHidden}>
                                <FullscreenMain>
                                    <FullscreenMainHeader>
                                        <KissHeader
                                            totalNumberOfFiles={totalFilesCount}
                                            currentPageNumber={currentFileIndex + 1}
                                            goBack={closeOverlayHandler}
                                            navNext={navNext}
                                            navPrev={navPrev}
                                            isSidebarHidden={isSidebarHidden}
                                            handleMaximize={handleMaximize}
                                            handleMinimize={handleMinimize}
                                            isPresentationMode={isPresentationMode}
                                        />
                                    </FullscreenMainHeader>
                                    {file.isGeneratedPreview && (
                                        <PreviewAlert downloadUrl={file.downloadUrl} />
                                    )}
                                    <FullscreenMainBody hasHeader>
                                        <KissFilePane file={file} />
                                    </FullscreenMainBody>
                                </FullscreenMain>
                            </FullscreenFrameMain>
                        </FullscreenFrameMainWrapper>
                        <FullscreenFrameSidebar isSidebarHidden={isSidebarHidden}>
                            {sidebarComponent}
                        </FullscreenFrameSidebar>
                    </FullscreenFrame>
                </FullscreenOverlay>
            )}
        </FileOverlayContextProvider>
    );
}

export default KissFileOverlay;
